import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
    selector: '[autofocus]'
})
export class Autofocus {
    constructor(element: ElementRef, renderer: Renderer) {
        renderer.invokeElementMethod(element.nativeElement, 'focus', []);
    }
}



// WEBPACK FOOTER //
// ./src/common/auto-focus/auto-focus.directive.ts